module.exports = __webpack_public_path__ + "static/logo-cn-6bd9963e82a5cba2d21e82e388e9aa47.png";